<template>
  <div>
    <div class="wrapper" v-if="show">
      <header class="main-header">
        <div class="container">
          <h1 class="mh-logo">
            <a href="https://hilfy.at" title="hilfy.at">
              <img
                src="/images/logo-hilfy.svg"
                width="119"
                height="50"
                alt="Hilfy"
              />
            </a>
          </h1>
        </div>
      </header>
      <section class="flex-center position-ref full-height">
        <div class="message">{{ $t("public.emailConfirmed") }}</div>
        <img src="/images/success.svg" height="120" alt="Flexbox Demo" />

        <section class="confirmation">
          <button class="confirmation__btn" @click="openApp">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background:new 0 0 512 512;"
              xml:space="preserve"
              fill="#fff"
              width="20px"
            >
              <g>
                <g>
                  <path
                    d="M298.667,25.6h-85.333c-4.71,0-8.533,3.823-8.533,8.533c0,4.71,3.823,8.533,8.533,8.533h85.333
			c4.71,0,8.533-3.823,8.533-8.533C307.2,29.423,303.377,25.6,298.667,25.6z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M358.4,25.6h-8.533c-4.71,0-8.533,3.823-8.533,8.533c0,4.71,3.823,8.533,8.533,8.533h8.533
			c4.71,0,8.533-3.823,8.533-8.533C366.933,29.423,363.11,25.6,358.4,25.6z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M266.598,435.2H245.41c-12.979,0-23.543,10.564-23.543,23.543v4.122c0,12.979,10.564,23.535,23.535,23.535h21.188
			c12.979,0,23.543-10.556,23.543-23.535v-4.122C290.133,445.764,279.569,435.2,266.598,435.2z M273.067,462.865
			c0,3.567-2.901,6.468-6.468,6.468H245.41c-3.575,0-6.477-2.901-6.477-6.468v-4.122c0-3.575,2.901-6.477,6.477-6.477h21.18
			c3.576,0,6.477,2.901,6.477,6.477V462.865z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M370.227,0H141.781c-17.007,0-30.848,13.841-30.848,30.848v450.304c0,17.007,13.841,30.848,30.848,30.848h228.437
			c17.007,0,30.848-13.841,30.848-30.839V30.848C401.067,13.841,387.226,0,370.227,0z M384,481.152
			c0,7.595-6.178,13.781-13.773,13.781H141.781c-7.603,0-13.781-6.187-13.781-13.773V30.848c0-7.595,6.178-13.781,13.781-13.781
			h228.437c7.603,0,13.781,6.187,13.781,13.781V481.152z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M392.533,51.2H119.467c-4.71,0-8.533,3.823-8.533,8.533v358.4c0,4.71,3.823,8.533,8.533,8.533h273.067
			c4.71,0,8.533-3.823,8.533-8.533v-358.4C401.067,55.023,397.244,51.2,392.533,51.2z M384,409.6H128V68.267h256V409.6z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
            <span>Zur mobilen App</span>
          </button>
          <button class="confirmation__btn" @click="openCabinet">
            <svg
              id="Capa_1"
              enable-background="new 0 0 513 513"
              height="20px"
              viewBox="0 0 513 513"
              width="20px"
              xmlns="http://www.w3.org/2000/svg"
              fill='#fff'
            >
              <g>
                <path
                  d="m482.162 34.04h-451.324c-17.004 0-30.838 13.834-30.838 30.838v292.025c0 17.004 13.834 30.838 30.838 30.838h159.15v38.075l-42.493 29.531c-4.678 3.251-6.677 9.088-4.973 14.524s6.676 9.088 12.373 9.088h203.211c5.697 0 10.669-3.652 12.373-9.088s-.295-11.273-4.973-14.524l-42.493-29.531v-38.075h159.15c17.004 0 30.838-13.834 30.838-30.838v-292.025c-.001-17.004-13.835-30.838-30.839-30.838zm-451.324 15h451.324c8.733 0 15.838 7.105 15.838 15.838v262.429h-483v-262.429c0-8.733 7.105-15.838 15.838-15.838zm451.324 323.701h-192.685c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h18.535v41.996c0 2.457 1.203 4.757 3.22 6.159l40.382 28.064h-190.227l38.452-26.723h82.091c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-76.941v-34.496h52.526c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-226.677c-8.733 0-15.838-7.105-15.838-15.838v-14.597h483v14.597c0 8.733-7.105 15.838-15.838 15.838z"
                />
                <path
                  d="m130.094 293c46.753 0 84.79-38.037 84.79-84.79s-38.037-84.79-84.79-84.79c-18.629 0-36.315 5.937-51.144 17.168-3.302 2.5-3.951 7.205-1.45 10.507 2.5 3.301 7.205 3.952 10.507 1.45 12.201-9.241 26.754-14.125 42.087-14.125 9.189 0 17.96 1.802 26.002 5.044l-31.719 59.526-56.396 36.98c-4.895-9.534-7.677-20.325-7.677-31.759 0-11.82 3.02-23.508 8.732-33.803 2.01-3.622.703-8.188-2.919-10.197s-8.188-.702-10.197 2.919c-6.945 12.516-10.616 26.721-10.616 41.081 0 46.753 38.036 84.789 84.79 84.789zm69.789-84.789c0 6.596-.94 12.974-2.658 19.027l-56.591-22.859 28.695-53.851c18.429 12.576 30.554 33.738 30.554 57.683zm-68.959 8.424 60.68 24.51c-11.783 21.917-34.932 36.855-61.51 36.855-21.677 0-41.075-9.935-53.885-25.489z"
                />
                <path
                  d="m272.106 147.49h182.726c7.843 0 14.224-6.381 14.224-14.224v-24.741c0-7.843-6.381-14.224-14.224-14.224h-23.732c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h22.956v23.188h-181.173v-23.188h126.255c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-127.032c-7.843 0-14.224 6.381-14.224 14.224v24.741c.001 7.844 6.382 14.224 14.224 14.224z"
                />
                <path
                  d="m272.106 221.886h108.873c7.843 0 14.224-6.381 14.224-14.224v-24.741c0-7.843-6.381-14.224-14.224-14.224h-108.873c-7.843 0-14.224 6.381-14.224 14.224v24.741c.001 7.843 6.382 14.224 14.224 14.224zm.777-38.188h107.32v23.188h-107.32z"
                />
                <path
                  d="m272.106 296.281h62.37c7.843 0 14.224-6.381 14.224-14.224v-24.741c0-7.843-6.381-14.224-14.224-14.224h-62.37c-7.843 0-14.224 6.381-14.224 14.224v24.741c.001 7.843 6.382 14.224 14.224 14.224zm.777-38.188h60.817v23.188h-60.817z"
                />
              </g>
            </svg>

            <span> Zur Web-App</span>
          </button>
        </section>
      </section>
    </div>

    <div class="wrapper" v-else>
      <header class="main-header">
        <div class="container">
          <h1 class="mh-logo">
            <a href="https://hilfy.at" title="hilfy.at">
              <img
                src="/images/logo-hilfy.svg"
                width="119"
                height="50"
                alt="Hilfy"
              />
            </a>
          </h1>
        </div>
      </header>

      <section class="flex-center position-ref full-height">
        <div style="color: rgb(244, 121, 41);" class="message">
          {{ $t("public.somethingWentWrong") }}
        </div>

        <div>
          <svg
            style="margin-top: 20px"
            width="100px"
            height="100px"
            viewBox="0 0 1085 1023"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>Group 20</title>
            <desc>Created with Sketch.</desc>
            <defs>
              <polygon
                id="path-1"
                points="0.658825844 0.191715556 180.048982 0.191715556 180.048982 15.7223822 0.658825844 15.7223822"
              ></polygon>
            </defs>
            <g
              id="Symbols"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="Patriotism/1/02"
                transform="translate(-178.000000, -541.000000)"
              >
                <g id="Group-20" transform="translate(177.648399, 541.000000)">
                  <path
                    d="M1043.3516,1023 C1041.56959,838.169441 1039.08109,677.454105 1039.39743,555.842822 C1039.60832,481.310622 1035.72795,1.46733693 980.685861,4.06582347 C934.311315,6.26291778 855.417647,119.106949 788.966445,255.147226 C788.924267,252.432547 297.351973,259.710422 297.351973,259.710422 C261.680057,200.47338 158.934815,-16.8593873 91.8931232,1.04481879 C19.5475665,20.3538977 33.5506126,574.158983 47.9121704,1023 L1043.3516,1023 Z"
                    id="Fill-1"
                    fill="#F47929"
                  ></path>
                  <path
                    d="M178.600601,464 L6.10260135,464 C2.92301306,464 0.351601056,461.317254 0.351601056,458 C0.351601056,454.682746 2.92301306,452 6.10260135,452 L178.600601,452 C181.780189,452 184.351601,454.682746 184.351601,458 C184.351601,461.317254 181.780189,464 178.600601,464"
                    id="Fill-3"
                    fill="#333132"
                  ></path>
                  <path
                    d="M11.1226008,553 C8.61695468,553 6.30405061,551.371787 5.57591414,548.871691 C4.69786722,545.87788 6.47537684,542.737004 9.54854104,541.875627 L175.981263,495.224689 C179.04372,494.352807 182.256086,496.096571 183.123425,499.100888 C184.01218,502.105204 182.223963,505.24608 179.161506,506.096952 L12.7180763,552.779403 C12.1933897,552.915963 11.6472873,553 11.1226008,553"
                    id="Fill-5"
                    fill="#333132"
                  ></path>
                  <path
                    d="M899.034515,451 C896.887987,451 894.825637,449.742341 893.868117,447.624744 C892.563365,444.700956 893.815506,441.261205 896.667021,439.928302 L1051.31172,367.532295 C1054.15271,366.188642 1057.53033,367.478549 1058.83509,370.391588 C1060.13984,373.293878 1058.8877,376.744378 1056.03618,378.077281 L901.391486,450.473288 C900.623366,450.828012 899.823679,451 899.034515,451"
                    id="Fill-7"
                    fill="#333132"
                  ></path>
                  <g
                    id="Group-11"
                    transform="translate(904.351601, 487.000000)"
                  >
                    <mask id="mask-2" fill="white">
                      <use xlink:href="#path-1"></use>
                    </mask>
                    <g id="Clip-10"></g>
                    <path
                      d="M6.37062993,15.7223822 C3.26614674,15.7223822 0.712629842,13.0486044 0.658825844,9.70353778 C0.606674784,6.31296 3.10721415,3.51402667 6.26467487,3.45713778 L174.235228,0.191715556 L174.341183,0.191715556 C177.445666,0.191715556 179.988588,2.86549333 180.052692,6.21056 C180.094543,9.58976 177.594003,12.3886933 174.436543,12.45696 L6.47658499,15.7223822 L6.37062993,15.7223822 Z"
                      id="Fill-9"
                      fill="#333132"
                      mask="url(#mask-2)"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getLink } from "@/mixins/getConfirmationLink";

export default {
  data() {
    return {
      show: false,
      appUrl: "",
    };
  },
  methods: {
    ...mapActions({
      confirm: "public/confirm",
    }),
    openCabinet() {
      const name = window.isAuthenticated === true ? "Public" : "Login";
      this.$router.push({ name });
    },
    openApp() { 
        window.location = this.appUrl; 
    },
  },
  async beforeMount() {
    const { email, code } = this.$route.query;
    const response = await this.confirm({ email, code });

    if (response.status != 200) {
      return;
    }

    this.show = true;

    const location = getLink.call(this);
    this.appUrl = location;
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  background-color: #9ccc85;
  color: #50318a;
  font-family: "Nunito", sans-serif;
  font-weight: 100;
  height: 100vh;
  margin: 0;
  animation: show 0.3s ease-out;
}

.container {
  width: 960px;
  max-width: 100%;
  padding: 20px;
  margin: 0 auto;
}

.main-header .container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}

.full-height {
  height: 60vh;
}

.flex-center {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.position-ref {
  position: relative;
}

.message {
  font-size: 26px;
  text-align: center;
  margin-bottom: 15px;
}

.image-cat {
  margin-top: 20px;
}

@keyframes show {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.confirmation {
    margin-top: 20px;
    display: flex;
    align-items: center;

    &__btn {
        width: 165px;
        height: 50px;
        margin: 10px;
        border-radius: 4px;
        background-color: #50318a;
        border: none;
        cursor: pointer;
        outline: none;
        color: #fff;
        font-size: 13px; 
        display: flex;
        align-items: center;
        justify-content: center;

        span {
            display: inline-block;
            margin-left: 10px;
        }
    }
}
</style>
